import React, { createContext, useEffect, useState } from 'react';

const DEFAULT_STARS_YEAR = 2026;

export const YearsContext = createContext({});
export const starsYearOptions = [2025, 2026,2027];

export function YearsProvider({ children }) {
  const [starsYear, setStarsYear] = useState();

  useEffect(() => {
    if (!starsYear) {
      let year = localStorage.getItem('starsYear');
      if (!year) {
        year = DEFAULT_STARS_YEAR;
      }
      setStarsYear(parseInt(year));
    }
  }, []);

  useEffect(() => {
    if (starsYear) {
      let yearString = starsYear.toString();
      localStorage.setItem('starsYear', yearString);
    }
  }, [starsYear]);

  const calendarYear = starsYear ? starsYear - 2 : null;
  const lastTwoDigitsOfStarsYear = starsYear ? parseInt(starsYear.toString().slice(-2)) : null;

  let value = {
    starsYear,
    setStarsYear,
    starsYearOptions,
    calendarYear,
    lastTwoDigitsOfStarsYear,
    DEFAULT_STARS_YEAR,
  };

  return <YearsContext.Provider value={value}>{children}</YearsContext.Provider>;
}
